export const CARGAR_PROFORMAS = 'CARGAR_PROFORMAS';
export const CARGAR_EMBALAJE = 'CARGAR_EMBALAJE';
export const CARGAR_PTOSFACTURACION = 'CARGAR_PTOSFACTURACION';
export const SELECCIONAR_PTOFACTURACION = 'SELECCIONAR_PTOFACTURACION';
export const CARGAR_FACTURA = 'CARGAR_FACTURA';
export const CARGAR_FACTURAS = 'CARGAR_FACTURAS';
export const CARGAR_PAGOS_FACTURA = 'CARGAR_PAGOS_FACTURA';
export const CARGAR_FACTURAS_PENDIENTESGUIAREMISION = 'CARGAR_FACTURAS_PENDIENTESGUIAREMISION';
export const CARGAR_DEVOLUCION_ELECTRON = 'CARGAR_DEVOLUCION_ELECTRON';
export const CARGAR_DEVOLUCION = 'CARGAR_DEVOLUCION';
export const CARGAR_GUIAREMISION = 'CARGAR_GUIAREMISION';
export const CARGAR_DEVOL_ELECTRONICAS = 'CARGAR_DEVOL_ELECTRONICAS';
export const SET_DOCSPORIMPRIMIR = 'SET_DOCSPORIMPRIMIR';
export const UPDATE_ESTADO_IMPRESION_DOCIMPRIMIR = 'UPDATE_ESTADO_IMPRESION_DOCIMPRIMIR';
export const INICIALIZAR_FACTURA = 'INICIALIZAR_FACTURA';
export const CARGAR_PROFORMAS_A_ENCARTONAR = 'CARGAR_PROFORMAS_A_ENCARTONAR';
export const RESET_PROFORMAS_A_ENCARTONAR = 'RESET_PROFORMAS_A_ENCARTONAR';
export const CARGAR_ITEMS_A_ENCARTONAR_POR_PROFORMA = 'CARGAR_ITEMS_A_ENCARTONAR_POR_PROFORMA';
export const DELETE_ITEMS_A_ENCARTONAR_POR_PROFORMA = 'DELETE_ITEMS_A_ENCARTONAR_POR_PROFORMA';
export const UPDATE_ESTADO_PROFORMA_ENCARTONADA = 'UPDATE_ESTADO_PROFORMA_ENCARTONADA';
export const UPDATE_ERRORES_VALIDACION_ITEM_A_ENCARTONAR = 'UPDATE_ERRORES_VALIDACION_ITEM_A_ENCARTONAR';
export const RESET_ITEMS_A_ENCARTONAR = 'RESET_ITEMS_A_ENCARTONAR';
export const ADD_CARTON = 'ADD_CARTON';
export const DELETE_CARTON = 'DELETE_CARTON';
export const UPDATE_CARTON = 'UPDATE_CARTON';
export const UPDATE_COD_ULT_CARTON = 'UPDATE_COD_ULT_CARTON';
export const UPDATE_PESO_CARTON = 'UPDATE_PESO_CARTON';
export const UPDATE_FLAG_PESO_AUTOMATICO = 'UPDATE_FLAG_PESO_AUTOMATICO';
export const CARGAR_ENCARTONADO = 'CARGAR_ENCARTONADO';
export const SET_ENCARTONADO_ID = 'SET_ENCARTONADO_ID';
export const SET_ENCARTONADO_OBSERVACION = 'SET_ENCARTONADO_OBSERVACION';
export const SET_ENCARTONADO_FECHA = 'SET_ENCARTONADO_FECHA';